import React, { FC, useEffect, useState } from "react"
import { RootState } from "../../../store"
import { connect } from "react-redux"
import { LCReleaseForm, ReleaseSubmissionProps } from "../../../types"
import { handleAuthorizedRequest, releases, users } from "../../../apis"
import { KButton, KSpan, KTitleSpan, KDropdown, KLogo, KInput } from "kahuna-base-react-components"
import { lang } from "../../../constants/languages"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import {
  ADMIN_PERMISSIONS,
  infoFilledToastOptions,
  successFilledToastOptions,
  USER_PERMISSION
} from "../../../constants"
import Loading from "../../ui/Loading"
import Summary from "../catalog/asset-registry/summary/Summary"
import ErrorModal from "../catalog/asset-registry/modal/ErrorModal"
import { toast } from "react-toastify"
//@ts-ignore
import RefreshIcon from "../../../assets/admin_icons/refresh.svg"
//@ts-ignore
import AlertIcon from "../../../assets/release-registry-icons/alert-triangle.svg"
import { useNavigate } from "react-router-dom"
import Pagination from "../../ui/table/Pagination"
import MediaPlayerComponent from "../catalog/asset-registry/summary/MediaPlayerComponent"
import { checkAdminPermission } from "../../../utility"

const ReleaseSubmission: FC<ReleaseSubmissionProps> = (props) => {
  const [userOptions, setUserOptions] = useState<KSelectOption[]>([])
  const [loading, setLoading] = useState(false)
  const [selectedUser, setSelectedUser] = useState<KSelectOption>()
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout>()
  const [errorText, setErrorText] = useState<string | undefined>(undefined)
  const [selectedTab, setSelectedTab] = useState(-1)

  const [searchUser, setSearchUser] = useState<boolean>(false)
  const [options, setOptions] = useState({})

  const [isPublishing, setIsPublishing] = useState(false)
  const [isMarketing, setIsMarketing] = useState(false)
  const [isState51, setIsState51] = useState(false)
  const [bmwCustomIdKeyword, setBmwCustomIdKeyword] = useState("")
  const [summaryPublishingText, setSummaryPublishingText] = useState("")
  const [releaseFormList, setReleaseFormList] = useState<LCReleaseForm[]>([])
  const [uploadDisabled, setUploadDisabled] = useState(false)
  const [isrcTrackIdMap, setIsrcTrackIdMap] = useState({})
  const [isrcProductIdMap, setIsrcProductIdMap] = useState({})
  const [isrcAssetTitleMap, setIsrcAssetTitleMap] = useState({})
  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(5)
  const [count, setCount] = useState(1)
  const [searchUpc, setSearchUpc] = useState("")
  const [playerSpotifyId, setPlayerSpotifyId] = useState<string>()
  const [checkedBoxes, setCheckedBoxes] = useState<{
    first: boolean
    second: boolean
    third: boolean
    fourth: boolean
  }>({
    first: false,
    second: false,
    third: false,
    fourth: false
  })

  const navigate = useNavigate()

  const fetchReleases = (offset: number, limit: number, searchUpc: string) => {
    //@ts-ignore
    if (!selectedUser || !options.labelOptions) {
      return
    }

    setLoading(true)
    releases(
      `/release/label_camp_product_release_submission/?user_id=${selectedUser.value}&offset=${offset}&limit=${limit}&upc=${searchUpc}`,
      "get"
    ).then((resp) => {
      const results: LCReleaseForm[] = [...resp.data.results.map((form: any) => form.result)]
      setReleaseFormList(results)
      setLoading(false)
      setCount(resp.data.count)
      const isrcProductIdMap: any = {}
      const isrcTrackIdMap: any = {}
      const isrcAssetTitleMap: any = {}
      results.forEach((releaseForm) => {
        releaseForm.tracks.forEach((track) => {
          if (track.data.attributes["isrc-code"] in isrcTrackIdMap) {
            isrcTrackIdMap[track.data.attributes["isrc-code"]].push(track.data.id)
          } else {
            isrcTrackIdMap[track.data.attributes["isrc-code"]] = [track.data.id]
          }

          isrcProductIdMap[track.data.attributes["isrc-code"]] = releaseForm.product.data.id

          const artistName = track.data.attributes["artist"].join(" | ")
          const trackTitle = track.data.attributes["title"]
          const isrc = track.data.attributes["isrc-code"]

          isrcAssetTitleMap[track.data.attributes["isrc-code"]] = `${artistName} - ${trackTitle} - ${isrc}`
        })
      })

      setIsrcTrackIdMap(isrcTrackIdMap)
      setIsrcProductIdMap(isrcProductIdMap)
      setIsrcAssetTitleMap(isrcAssetTitleMap)
    })
  }

  useEffect(() => {
    fetchReleases(offset, limit, searchUpc)
  }, [selectedUser, options, offset, limit])

  useEffect(() => {
    localStorage.removeItem("releaseSubmission")

    const userPermissionIds = props.user.permissionUser.map((up) => up?.permission?.id || 0)
    if (userPermissionIds.includes(USER_PERMISSION.UPLOAD_MESAM)) {
      setIsPublishing(true)
      setSummaryPublishingText(lang.catalog.asset_registry.summary_publishing_mesam)
    } else if (userPermissionIds.includes(USER_PERMISSION.UPLOAD_MSG)) {
      setIsPublishing(true)
      setSummaryPublishingText(lang.catalog.asset_registry.summary_publishing_msg)
    }

    if (userPermissionIds.includes(USER_PERMISSION.UPLOAD_BMV)) {
      setBmwCustomIdKeyword(props.user.bmwCustomId)
    }

    if (userPermissionIds.includes(USER_PERMISSION.UPLOAD_MARKETING)) {
      setIsMarketing(true)
    }

    if (userPermissionIds.includes(USER_PERMISSION.UPLOAD_STATE51)) {
      setIsState51(true)
    }

    setLoading(true)
    releases(`/release/label_camp_options/`, "get").then((resp) => {
      setLoading(false)
      const labelOptions = resp.data["label_options"]
      const productTypeOptions = resp.data["product_type_options"]
      const languageOptions = resp.data["language_options"]
      const metadataLanguageOptions = resp.data["metadata_language_options"]
      const productGenreOptions = resp.data["product_genre_options"]
      const distributorProductSubGenreOptions = resp.data["distributor_product_sub_genre_options"]
      const distributorPriceCodeOptions = resp.data["distributor_price_code_options"]
      const distributorTrackPriceOptions = resp.data["distributor_track_price_options"]
      const userGenre = resp.data["user_genre"]
      const roleOptions = resp.data["roles"]
      setOptions({
        labelOptions,
        productTypeOptions,
        languageOptions,
        metadataLanguageOptions,
        productGenreOptions,
        distributorProductSubGenreOptions,
        distributorPriceCodeOptions,
        distributorTrackPriceOptions,
        roleOptions
      })
      if (props.user.id && !props.isAdmin) setSelectedUser({ value: props.user.id, label: "" })
    })
  }, [])

  const onSearchTextChanged = async (text: string) => {
    if (!text) return
    setUserOptions([])
    clearTimeout(timeoutId)
    setTimeoutId(
      setTimeout(async () => {
        await handleAuthorizedRequest(async () => {
          const response = await users(`/?limit=10&offset=0&username=${text}`, "get")
          setUserOptions(
            response.data.results.map((user: any) => ({
              value: user.id,
              label: user.username
            }))
          )
        }, "")
      }, 500)
    )
  }

  const handleFileChange = (e: any) => {
    if (!selectedUser) {
      return
    }

    const files = e.target.files
    if (files && files.length > 0) {
      try {
        const formData = new FormData()
        Array.from(files).forEach((file: any) => {
          formData.append("files", file)
        })
        formData.append(
          "metadata_map",
          JSON.stringify({
            isrc_product_id_map: isrcProductIdMap,
            isrc_track_id_map: isrcTrackIdMap,
            isrc_asset_title_map: isrcAssetTitleMap
          })
        )

        setLoading(true)
        releases(`/release/label_camp_upload_takedown_tracks/?user_id=${selectedUser.value}`, "post", formData).then(
          (resp) => {
            setLoading(false)
            if (resp?.data?.error_count) {
              toast.info(
                `Success: ${resp.data.success_count}, Error: ${resp.data.error_count}, Message: ${resp.data.error_message}`,
                infoFilledToastOptions
              )
            } else if (resp?.data?.success_count) {
              toast.success(`Successfully uploaded ${resp.data.success_count} assets`, successFilledToastOptions)
            } else {
              setErrorText("Error uploading assets.")
            }
            setUploadDisabled(false)
          }
        )
      } catch (error: any) {
        setErrorText("Error uploading assets.")
        setUploadDisabled(false)
        setLoading(false)
      }
    } else {
      console.log("No files selected")
      setUploadDisabled(false)
    }
  }

  const onSubmitRelease = (releaseForm: LCReleaseForm) => {
    setReleaseFormList([
      ...releaseFormList.map((form) => {
        if (releaseForm.product.data.id === form.product.data.id) {
          form.product.data.attributes["status"] = "reviewing"
        }
        return form
      })
    ])

    toast.success(lang.release_submission.submit_success, successFilledToastOptions)
  }

  const onClickPagination = (pageNumber: number) => {
    setOffset((pageNumber - 1) * limit)
  }

  return (
    <div className="catalog flex flex-col bg-[#fff] px-8 pt-8">
      {loading && <Loading />}
      <ErrorModal text={errorText} setText={setErrorText} />
      <MediaPlayerComponent spotifyId={playerSpotifyId} youtubeId={undefined} />
      <div className="flex justify-between items-center mb-6">
        {!props.isAdmin && (
          <div className="mr-28 cursor-pointer" onClick={() => navigate("/overview")}>
            <KLogo width={48} height={48} primaryTextVisible={true} logoColor="white" borderRadius={1} />
          </div>
        )}
        <KTitleSpan fontSize={20} lineHeight="28px" text={lang.release_submission.title} />
        {props.isAdmin &&
          selectedUser &&
          checkAdminPermission(ADMIN_PERMISSIONS.RELEASE_SUBMISSION_UPLOAD_TRACK, props.user?.adminPermissions) && (
            <div>
              <KSpan text="Upload track assets: " />
              <input type="file" multiple onChange={handleFileChange} />
            </div>
          )}
        {props.isAdmin && (
          <div>
            {searchUser ? (
              <div
                className="relative"
                style={{ width: 250 }}
                onKeyDown={(event) => {
                  if (event.key === "Escape") {
                    setSearchUser(false)
                  }
                }}
              >
                <KDropdown
                  dataTestId="release-submission-search-user"
                  placeholder={"Search user to filter"}
                  width={240}
                  selected={selectedUser}
                  onInputChange={onSearchTextChanged}
                  options={userOptions}
                  onSelect={(selectedOption) => {
                    setSelectedUser(selectedOption as KSelectOption)
                  }}
                />
              </div>
            ) : (
              <div className="">
                <KButton
                  dataTestId="release-submission-search-user-button"
                  leftIcon="/reports_icons/user.svg"
                  gap="4px"
                  text="Search user"
                  height="36px"
                  width="auto"
                  background="#F7F7F7"
                  hoverBackground="#F3F3F3"
                  activeBackground="#F7F7F7"
                  padding="8px"
                  shadowDisabled
                  onClick={() => {
                    setSearchUser(true)
                  }}
                />
              </div>
            )}
          </div>
        )}
        <div>
          <KInput dataTestId="release-submission-search-upc-input" onChange={(text) => setSearchUpc(text)} value={searchUpc} placeholder="Search UPC" />
        </div>
        <div>
          <KButton
            dataTestId="release-submission-refresh-button"
            width="50px"
            height="30px"
            shadowDisabled
            icon={RefreshIcon}
            onClick={() => fetchReleases(offset, limit, searchUpc)}
            background="white"
            padding="8px"
          />
        </div>
      </div>
      <div className={`grow flex justify-center`}>
        <div className={"w-full"}>
          {!props.isAdmin && (
            <div className="mt-8 mb-4">
              <div className="flex flex-col gap-3 pl-1">
                <div className="flex flex-row gap-2">
                  <div className="pt-0.5">
                    <KInput
                      value={"checkTerms"}
                      onChange={() => {
                        setCheckedBoxes({ ...checkedBoxes, first: !checkedBoxes.first })
                      }}
                      type={"checkbox"}
                      checked={checkedBoxes.first}
                      shadowDisabled={true}
                      width={16}
                      height={16}
                      accentColor={"black"}
                      padding="0px"
                      borderRadius={10}
                    />
                  </div>
                  <KSpan
                    text={lang.catalog.asset_registry.summary.correct_labeling_explicit_content}
                    lineHeight="20px"
                  />
                </div>
                <div className="flex flex-row gap-2 items-start">
                  <KInput
                    value={"checkTerms"}
                    onChange={() => {
                      setCheckedBoxes({ ...checkedBoxes, second: !checkedBoxes.second })
                    }}
                    type={"checkbox"}
                    checked={checkedBoxes.second}
                    shadowDisabled={true}
                    width={16}
                    height={16}
                    accentColor={"black"}
                    padding="0px"
                    borderRadius={10}
                  />
                  <KSpan text={lang.catalog.asset_registry.summary.authorised_to_distribute} lineHeight="20px" />
                </div>
                <div className="flex flex-row gap-2 items-start">
                  <div className="pt-0.5">
                    <KInput
                      value={"checkTerms"}
                      onChange={() => {
                        setCheckedBoxes({ ...checkedBoxes, third: !checkedBoxes.third })
                      }}
                      type={"checkbox"}
                      checked={checkedBoxes.third}
                      shadowDisabled={true}
                      width={16}
                      height={16}
                      accentColor={"black"}
                      padding="0px"
                      borderRadius={10}
                    />
                  </div>
                  <KSpan text={lang.catalog.asset_registry.summary.no_plagiarism} lineHeight="20px" />
                </div>
                <div className="flex flex-row gap-2 items-start">
                  <div className="pt-0.5">
                    <KInput
                      value={"checkTerms"}
                      onChange={() => {
                        setCheckedBoxes({ ...checkedBoxes, fourth: !checkedBoxes.fourth })
                      }}
                      type={"checkbox"}
                      checked={checkedBoxes.fourth}
                      shadowDisabled={true}
                      width={16}
                      height={16}
                      accentColor={"black"}
                      padding="0px"
                      borderRadius={10}
                    />
                  </div>
                  <KSpan text={lang.catalog.asset_registry.summary.no_mislabeling} lineHeight="20px" />
                </div>
              </div>
              <div className="mt-4">
                <div className="px-[14px] pt-[14px] pb-4 flex flex-row gap-3 bg-[#FFF7EA] rounded-[10px]">
                  <div className="shrink-0">
                    <img src={AlertIcon} style={{ width: 20 }} />
                  </div>
                  <div className="opacity-80 inline-flex">
                    <KSpan text={lang.catalog.asset_registry.summary.warning_text} color="#4D360E" />
                  </div>
                </div>
              </div>
            </div>
          )}
          {releaseFormList.map((releaseForm: LCReleaseForm, index: number) => {
            return (
              <div
                className="mb-8"
                key={`release_submission_${index}`}
                style={{ border: "1px solid #66666640", borderRadius: 5 }}
              >
                <Summary
                  releaseForm={releaseForm}
                  options={options}
                  setSelectedTab={(value: number) => {}}
                  fetchProduct={(productId: string) => {}}
                  setErrorText={setErrorText}
                  isPublishing={isPublishing}
                  summaryPublishingText={summaryPublishingText}
                  bmwCustomIdKeyword={bmwCustomIdKeyword}
                  isMarketing={isMarketing}
                  isReleaseSubmission={true}
                  isAdmin={props.isAdmin}
                  editDisabled={
                    props.isAdmin &&
                    !checkAdminPermission(ADMIN_PERMISSIONS.RELEASE_SUBMISSION_WRITE, props.user?.adminPermissions)
                  }
                  onSubmitRelease={() => onSubmitRelease(releaseForm)}
                  setPlayerSpotifyId={setPlayerSpotifyId}
                  submitDisabled={
                    !checkedBoxes.first || !checkedBoxes.second || !checkedBoxes.third || !checkedBoxes.fourth
                  }
                />
              </div>
            )
          })}
          <div>
            <Pagination
              key={""}
              hidden={false}
              size={"sm"}
              pageCount={Math.ceil(count / limit)}
              currentPage={offset / limit + 1}
              onClickPage={onClickPagination}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps, {})(ReleaseSubmission)
